import React from 'react';

export const EntryAssetImage = (props) => {
  const { imageUrl } = props;

  return <div className='entryAssetImageContainer'>
    <img className={'imageAsset'} src={imageUrl} alt={''}/>
    <a className={'imageAssetLink'} href={imageUrl} target={'_blank'}>View Full Size</a>
  </div>
}